// src/pages/legal/TextPage.jsx
// The frame of the text pages (privacy policy, terms, help): a title, a way back, and the text.
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '../../components/icons';
import { CONTACT_EMAIL, OPERATOR_NAME } from '../../config';

export const operatorName = () => OPERATOR_NAME || 'the operator of Tournamental';

// How to reach the operator: the address if one is configured, else a pointer that does not invent one.
export function Contact() {
    if (CONTACT_EMAIL) return <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>;
    return <>the contact details given where you found this app (its site or store listing)</>;
}

function TextPage({ title, updated, children }) {
    useEffect(() => {
        document.title = `${title} · Tournamental`;
    }, [title]);
    return (
        <main className="text-page">
            <Link className="btn btn-ghost btn-sm back-link" to="/dashboard">
                <ArrowLeftIcon size={16} /> Back to the app
            </Link>
            <h1>{title}</h1>
            {updated && <p className="updated">Last updated: {updated}</p>}
            {children}
        </main>
    );
}

export default TextPage;
